import { FC, MutableRefObject, RefObject, Dispatch, SetStateAction, useEffect, useState, MouseEvent } from "react";
import { PCNavListItemType } from "../../../utils/projectUtils";
import { CheckCircleIcon, ExclamationCircleIcon, ExclamationTriangleIcon } from "@patternfly/react-icons";
import { Tabs, Tab, TabTitleText, TabTitleIcon } from "@patternfly/react-core";
import { useHistory } from "react-router-dom";
import "./ProjectDetailsSidenav.scss";
import { useProjectChecklist } from "../../../queries/getProjectChecklist";
import { useParams } from "react-router";
import { CWRouteParams } from "../../../constants/router";

interface NavigationIconProps {
  iconStatus: string
}
enum IconStatus {
  INCOMPLETE_REQUIRED_FIELDS = 'INCOMPLETE_REQUIRED_FIELDS',
  INCOMPLETE_NON_REQUIRED_FIELDS = 'INCOMPLETE_NON_REQUIRED_FIELDS',
  COMPLETE_FIELDS = 'COMPLETE_FIELDS'
}
const NavigationIcon: FC<NavigationIconProps> = (props: NavigationIconProps) => {
  switch (props.iconStatus as IconStatus) {
    case IconStatus.INCOMPLETE_REQUIRED_FIELDS:
      return <ExclamationCircleIcon color="#C9190B" />
    case IconStatus.INCOMPLETE_NON_REQUIRED_FIELDS:
      return <ExclamationTriangleIcon />
    case IconStatus.COMPLETE_FIELDS:
      return <CheckCircleIcon />
    default: return <></>
  }
}

interface SidenavListItem extends PCNavListItemType {
  validationStatus?: IconStatus
}
const ProjectDetailsSidenav: FC<{
  navList: PCNavListItemType[],
  contentRefs: MutableRefObject<{[key: number]: RefObject<any>}>,
  activeTabKey: number,
  setActiveTabKey: Dispatch<SetStateAction<number>>
}> = ({navList, contentRefs, activeTabKey}) => {
  const history = useHistory();
  const params = useParams<CWRouteParams>()
  const { data: checklistStats } = useProjectChecklist(params.id);
  const [sidenavList, setSideNavList] = useState<SidenavListItem[]>();

  useEffect(() => {
    let newNavList  = navList as SidenavListItem[];
    checklistStats?.items?.forEach((item) => {
      item?.checklistItems?.forEach((checklist) => {
        newNavList = newNavList.map((nav) => {
          if (checklist.name.endsWith(nav.postFixName)) {
            nav.validationStatus = checklist.status === "COMPLETED" ?
              IconStatus.COMPLETE_FIELDS :
              (checklist.optional ? IconStatus.INCOMPLETE_NON_REQUIRED_FIELDS :
                IconStatus.INCOMPLETE_REQUIRED_FIELDS);
          }
          return nav;
        })
      });
    });
    setSideNavList(newNavList);
  }, [navList, checklistStats]);

  const handleTabClick = (_event: MouseEvent<HTMLElement>, tabIndex: string | number) => {
    const index = typeof tabIndex === 'string' ? parseInt(tabIndex) : tabIndex;
    const selectedTab = sidenavList?.[index];
    if (selectedTab) {
      history.push(selectedTab.path);
      setTimeout(() => {
        document.getElementById(`tab-content-${index}`)?.focus();
      }, 0);
    }
  };

  return (
    <Tabs
      activeKey={activeTabKey}
      onSelect={handleTabClick}
      isVertical
      className="project-detail-sidenav"
    >
      {sidenavList?.map(({validationStatus, text}, index) => (
        <Tab
          key={index}
          eventKey={index}
          tabContentId={`tab-content-${index}`}
          tabContentRef={contentRefs.current[index]}
          title={
            <div className="project-detail-sidenav__wrapper">
              <div className="project-detail-sidenav__wrapper__child">
                {validationStatus && (
                  <TabTitleIcon>
                    <NavigationIcon iconStatus={validationStatus} />
                  </TabTitleIcon>
                )}
              </div>
              <TabTitleText>{text}</TabTitleText>
            </div>
          }
        />
      ))}
    </Tabs>
  )
};
export default ProjectDetailsSidenav;
